import React from 'react';
import Icon from '@/components/ui/Icon';
import { useModalManager } from '@/components/common/Modal';
import AddRubricModal from '@/components/staffer/ExerciseBuilder/Rubric/AddRubricModal';
import { UnstyledButton } from '@/components/ui/Buttons';
import {
  IRubricModalQuestion,
  IRubricModalQuestionTranslation,
} from '@/components/staffer/ExerciseBuilder/Rubric/AddRubricModal/AddRubricModal.types';

interface IEditRubricButtonProps {
  question: IRubricModalQuestion;
  translations: [IRubricModalQuestionTranslation<'en'>, IRubricModalQuestionTranslation<'es'>];
}

const EditRubricButton = ({ question, translations }: IEditRubricButtonProps) => {
  const { close, isOpen, open } = useModalManager();

  return (
    <>
      <UnstyledButton className="!tw-cursor-pointer" onClick={open}>
        <Icon
          className="tw-pointer-events-none"
          fill="#522E91"
          icon="Writing"
          size={22}
        />
      </UnstyledButton>
      <AddRubricModal
        isOpen={isOpen}
        question={question}
        translations={translations}
        onClose={close}
      />
    </>
  );
};

export default EditRubricButton;
